import type { QueryClient } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import type { CreateUserBody } from "@shared/schemas/user-write.schemas";
import {
  UserAdminViewSchema,
  type UserAdminView,
} from "@shared/schemas/user-views.schemas";
import { BaseApiHooksRepository } from "../../base-api-hooks.repository";
import { createUsersAdminApi } from "./users-admin.api";

export class UsersAdminHooksHttpRepositoryImpl extends BaseApiHooksRepository {
  private readonly api;

  constructor(queryClient: QueryClient, apiClient: AxiosInstance) {
    super(queryClient);
    this.api = createUsersAdminApi(apiClient);
  }

  createHooks() {
    return {
      useCreateUser: () =>
        this.mutation<UserAdminView, UserAdminView, CreateUserBody>({
          fn: (body) => this.api.create(body),
          parse: (dto) => UserAdminViewSchema.parse(dto),
        }),
    };
  }
}
